

interface Config {
    pizza_meioamio_payment: 'maior'|'metade';
}
export const configuation: Config = {
    pizza_meioamio_payment: 'maior'
};